import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/NotFound.css";

const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Set document title
    document.title = "404 - Səhifə tapılmadı | DostTech";
    
    // Update HTTP status code for SEO (client-side)
    // Note: For proper 404 status, server configuration is needed
  }, []);

  const handleGoHome = () => {
    // Extract language from path or default to 'az'
    const pathSegments = location.pathname.split("/");
    const lang = pathSegments[1] || "az";
    navigate(`/${lang}/`);
  };

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="not-found-icon">
          <h1>404</h1>
        </div>
        <h2>Səhifə tapılmadı</h2>
        <p>Axtardığınız səhifə mövcud deyil və ya silinib.</p>
        <button onClick={handleGoHome} className="not-found-button">
          Ana səhifəyə qayıt
        </button>
      </div>
    </div>
  );
};

export default NotFound;

